<!-- 心情选择 组件 -->
<template>
  <div>
    <div class="chat-card">
      <div class="emotion-card" v-for="(item, index) in emotionArr" :key="index" :style="`backgroundColor: ${item.cardBg}; borderColor: ${item.cardBorder}`">
        <div class="emotion-card-title">
          <span class="title-icon" :style="`color: ${item.iconColor}`">“</span>
          <div class="title">
            {{ item.title }}
          </div>
          <img class="emotion-icon" :src="item.icon" />
        </div>
        <div class="emotion-card-content">
          <Row type="flex" justify="space-between" gutter="4">
            <Col span="8" v-for="(listItem, listIndex) in item.list" :key="'list' + '-' + index + '-' + listIndex">
                <div class="card-content-text" @click="selectEmotioon(listItem.label)">
                  {{ listItem.label }}
                  <div v-if="isSelect(listItem.label)" class="badge">
                    {{ isSelect(listItem.label) }}
                  </div>
                </div>
            </Col>
          </Row>
        </div>
      </div>
      <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">确定</button>
    </div>
    <!-- <div class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>
import { Row, Col } from 'vant'
export default {
  name: 'ChatConfirm',
  components: { Row, Col },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  data() {
    return {
      selectEmotion: [],
      emotionArr: [
        {
          title: '恐惧',
          icon: require('@/assets/images/emotion-icon-1.png'),
          iconColor: '#D1DBFF',
          cardBg: '#E8EDFF',
          cardBorder: '#D1DBFF',
          list: [
            {
              label: '不安全',
              value: '',
            },
            {
              label: '紧张',
              value: '',
            },
            {
              label: '恐惧',
              value: '',
            },
            {
              label: '担忧',
              value: '',
            },
            {
              label: '震惊',
              value: '',
            },
            {
              label: '焦虑',
              value: '',
            },
            {
              label: '胆怯',
              value: '',
            },
            {
              label: '怀疑',
              value: '',
            },
            {
              label: '崩溃',
              value: '',
            },
            {
              label: '紧绷',
              value: '',
            },
            {
              label: '疑神疑鬼',
              value: '',
            },
            {
              label: '困惑',
              value: '',
            },
          ],
        },
        {
          title: '快乐',
          icon: require('@/assets/images/emotion-icon-2.png'),
          iconColor: '#BAF7D5',
          cardBg: '#E8FFF2',
          cardBorder: '#BAF7D5',
          list: [
            {
              label: '喜悦',
              value: '',
            },
            {
              label: '欢乐',
              value: '',
            },
            {
              label: '欢喜',
              value: '',
            },
            {
              label: '辛福',
              value: '',
            },
            {
              label: '开心',
              value: '',
            },
            {
              label: '愉悦',
              value: '',
            },
            {
              label: '满足',
              value: '',
            },
            {
              label: '满心喜悦',
              value: '',
            },
            {
              label: '欣喜',
              value: '',
            },
            {
              label: '兴趣十足',
              value: '',
            },
            {
              label: '兴奋',
              value: '',
            },
            {
              label: '激情四射',
              value: '',
            },
          ],
        },
        {
          title: '坚定',
          icon: require('@/assets/images/emotionalRecognition-icon.png'),
          iconColor: '#F5DCAE',
          cardBg: '#FFF9ED',
          cardBorder: '#F5DCAE',
          list: [
            {
              label: '骄傲',
              value: '',
            },
            {
              label: '有力量',
              value: '',
            },
            {
              label: '有价值',
              value: '',
            },
            {
              label: '尊重',
              value: '',
            },
            {
              label: '值得',
              value: '',
            },
            {
              label: '无畏',
              value: '',
            },
            {
              label: '重要',
              value: '',
            },
            {
              label: '决心',
              value: '',
            },
            {
              label: '赋能',
              value: '',
            },
            {
              label: '豁达',
              value: '',
            },
            {
              label: '灵活',
              value: '',
            },
            {
              label: '自信',
              value: '',
            },
          ],
        },
        {
          title: '愤怒',
          icon: require('@/assets/images/emotion-icon-4.png'),
          iconColor: '#FCDCC5',
          cardBg: '#FFF2E8',
          cardBorder: '#FCDCC5',
          list: [
            {
              label: '暴怒',
              value: '',
            },
            {
              label: '烦躁',
              value: '',
            },
            {
              label: '苦闷',
              value: '',
            },
            {
              label: '憎恨',
              value: '',
            },
            {
              label: '暴躁',
              value: '',
            },
            {
              label: '嫉妒',
              value: '',
            },
            {
              label: '沮丧',
              value: '',
            },
            {
              label: '苦恼',
              value: '',
            },
            {
              label: '厌恶',
              value: '',
            },
            {
              label: '火大',
              value: '',
            },
            {
              label: '敌对',
              value: '',
            },
            {
              label: '心烦',
              value: '',
            },
          ],
        },
        {
          title: '平静',
          icon: require('@/assets/images/emotion-icon-5.png'),
          iconColor: '#CFECFF',
          cardBg: '#F2F8FC',
          cardBorder: '#CFECFF',
          list: [
            {
              label: '释然',
              value: '',
            },
            {
              label: '平和',
              value: '',
            },
            {
              label: '安定',
              value: '',
            },
            {
              label: '专注',
              value: '',
            },
            {
              label: '沉静',
              value: '',
            },
            {
              label: '舒适',
              value: '',
            },
            {
              label: '平安',
              value: '',
            },
            {
              label: '放松',
              value: '',
            },
            {
              label: '释怀',
              value: '',
            },
            {
              label: '知足',
              value: '',
            },
            {
              label: '乐观',
              value: '',
            },
            {
              label: '接纳',
              value: '',
            },
          ],
        },
        {
          title: '悲伤',
          icon: require('@/assets/images/emotion-icon-6.png'),
          iconColor: '#FCB4AC',
          cardBg: '#FFEDED',
          cardBorder: '#FCB4AC',
          list: [
            {
              label: '羞愧',
              value: '',
            },
            {
              label: '丢脸',
              value: '',
            },
            {
              label: '自卑',
              value: '',
            },
            {
              label: '孤独',
              value: '',
            },
            {
              label: '脆弱',
              value: '',
            },
            {
              label: '受伤',
              value: '',
            },
            {
              label: '无力',
              value: '',
            },
            {
              label: '无意义',
              value: '',
            },
            {
              label: '心碎',
              value: '',
            },
            {
              label: '绝望',
              value: '',
            },
            {
              label: '无助',
              value: '',
            },
            {
              label: '失望',
              value: '',
            },
          ],
        },
      ],
    };
  },
  created() {},
  mounted() {
    if(this.nextData?.step_data?.survey?.qstList[0].answer.val) {
      let useData = this.nextData.step_data.survey.qstList[0].answer.val;
      this.selectEmotion = useData;
    }
  },
  methods: {
    // 选择心情
    selectEmotioon(val) {
      if(!this.isCanEdit) {
        return;
      }
      console.log(val)
      const findIndex = this.selectEmotion.findIndex(item => item === val);
      if(findIndex === -1) {
        this.selectEmotion.push(val);
      } else {
        this.selectEmotion.splice(findIndex, 1);
      }
    },
    // 是否选中
    isSelect(val) {
      const findIndex = this.selectEmotion.findIndex(item => item === val);
      if(findIndex === -1) {
        return false;
      } else {
        return findIndex + 1;
      }
    },

    confirmFn() {
      if(!this.selectEmotion.length) {
        this.$toast('请选择至少俩个情绪');
        return;
      }
      const useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: {
                  val: this.selectEmotion
                },
              },
            ],
          },
        },
      };
      this.$emit('confirmFn', useData);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 342px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: -10px;
  .emotion-card {
    width: 167px;
    padding: 8px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #D1DBFF;
    background-color: #E8EDFF;
    margin-top: 10px;
    
    .emotion-card-title {
      position: relative;
      width: 100%;
      height: 30px;
      overflow: hidden;
      .title-icon {
        height: 30px;
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        font-size: 60px;
        position: absolute;
        z-index: 9;
        top: -6px;
        left: -4px;
      }
      .title {
        font-size: 16px;
        font-weight: 600;
        color: rgba(18, 18, 18, 1);
        position: absolute;
        z-index: 99;
        top: 8px;
        left: 0px;
      }
      .emotion-icon {
        width: 30px;
        height: 30px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .emotion-card-content {
      margin-top: 5px;
      .card-content-text {
        width: 100%;
        font-size: 8px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 16px;
        color: rgba(18, 18, 18, 0.4);
        text-align: center;
        background-color: #fff;
        margin-bottom: 2px;
        text-align: center;
        white-space: nowrap;
        position: relative;
        .badge {
          width: 10px;
          height: 10px;
          font-size: 6px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          right: -3px;
          top: -3px;
          background: #3895FF;
          border-radius: 50%;
          z-index: 99;
        }
      }
    }
  }
  .confirm-btn {
    width: 76px;
    height: 25px;
    border-radius: 12px;
    background: #3895FF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.23px;
    color: #fff;
    border: none;
    margin: 10px auto 0;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
